import React, { Component } from 'react';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import withStyles from '@material-ui/core/styles/withStyles';

import PreviewNotification from 'assets/img/previews/Preview_iOS_Notification.png';

import PreviewControls from 'assets/img/previews/Preview_iOS.png';
import PreviewBG from 'assets/img/previews/Preview_iOS_BG.png';
import PreviewBGImage from 'assets/img/previews/Preview_iOS_BG_Image.png';

import styles from 'assets/jss/material-dashboard-pro-react/components/notificationsPreviewStyles';

class NotificationsPreview extends Component {

	state = {
		isVerifiedImageError: false,
		isFraudImageError: false,
	}

	componentDidUpdate(prevProps) {
		if (this.props.verifiedImage !== prevProps.verifiedImage) {
			this.setState({
				isVerifiedImageError: false,
			});
		}
		if (this.props.fraudImage !== prevProps.fraudImage) {
			this.setState({
				isFraudImageError: false,
			});
		}
	}

	onVerifiedImageError = () => {
		this.setState({
			isVerifiedImageError: true,
		});
	}

	onFraudImageError = () => {
		this.setState({
			isFraudImageError: true,
		});
	}

	render() {
		const { isVerifiedImageError } = this.state;
		const {
			organizationName,
			classes,
			enterpriseName,
			phoneNumber,
			notification,
			unverifiedCall,
			verifiedImage,
			defaultVerifiedImage,
		} = this.props;
		const currentPhoneNumber = phoneNumber ? `+${phoneNumber}` : ' ';

		return (
			<GridContainer className={classes.previewDeviceContainer}>
				<GridItem xs={12} sm={12} md={4} className={classes.previewImageIos}>
					<img
						src={PreviewNotification}
						alt="Preview Notification"
					/>
					<div className={classes.iosPushNotification}>
						<span className={classes.firstLine}>{`${enterpriseName} Pre Call Notification`}</span> <br />
						<span>{`You will receive a phone call from ${organizationName}`}</span> <br />
						<span>{notification}</span>
					</div>
				</GridItem>
				<GridItem xs={12} sm={12} md={4} className={classes.previewImageIos}>
					<img
						className={classes.absoluteImage}
						src={PreviewBG}
						alt="Preview Background"
					/>
					<div className={classes.previewIosImageContainer}>
						{
							((verifiedImage || defaultVerifiedImage) && !isVerifiedImageError) &&
							<img
								src={verifiedImage || defaultVerifiedImage}
								onError={this.onVerifiedImageError}
								className={classes.notificationPreviewImageIos}
								alt="Verified Logo"
							/>
						}
					</div>
					<div className={classes.saturation}></div>
					<img
						className={classes.absoluteImage}
						src={PreviewControls}
						alt="Preview Controls"
					/>
					<div className={classes.iosCallNumber}>
						<span>{`${organizationName}`}</span> <br />
					</div>
					<div className={classes.iosCallMessage}>
						<span>{notification}</span>
					</div>
				</GridItem>
				<GridItem xs={12} sm={12} md={4} className={classes.previewImageIos}>
					<img
						className={classes.absoluteImage}
						src={PreviewBGImage}
						alt="Preview Background"
					/>
					<img
						className={classes.absoluteImage}
						src={PreviewControls}
						alt="Preview Controls"
					/>
					<div className={classes.iosCall}>
						<span className={classes.iosCallNumber}>{`${currentPhoneNumber}`}</span> <br />
						<span className={classes.iosCallMessage}>{unverifiedCall}</span>
					</div>
				</GridItem>
			</GridContainer>
		)
	}
}

export default withStyles(styles)(NotificationsPreview);